<template>
<nav>
  <!-- <menuOverlay :hovered="hovered"></menuOverlay> -->
  <p class="nav-button sine-nav" @mouseover="handleHoverEnter" @mouseleave="handleHoverLeave">
    <router-link to="/" data-length="5" @click.native="handleMobile()">Home</router-link>
  </p>
  <p v-if="!isMobile" class="nav-button sine-nav" @mouseover="handleHoverEnter" @mouseleave="handleHoverLeave">
    <!-- <p v-if="!isMobile" class="nav-button sine-nav" @mouseover="hovered2 = true" @mouseleave="hovered2 = false"> -->
    <router-link to="/journey" data-length="6" @click.native="handleMobile()">Journey</router-link>
  </p>
  <p class="nav-button sine-nav" @mouseover="handleHoverEnter" @mouseleave="handleHoverLeave">
    <router-link to="/shop" data-length="6" @click.native="handleMobile()">Shop</router-link>
  </p>
  <p class="nav-button sine-nav" @mouseover="handleHoverEnter" @mouseleave="handleHoverLeave">
    <router-link to="/meditation" data-length="5" @click.native="handleMobile()">Meditation</router-link>
  </p>
  <p class="nav-button sine-nav" @mouseover="handleHoverEnter" @mouseleave="handleHoverLeave">
    <router-link to="/credits" data-length="4" @click.native="handleMobile()">Credits</router-link>
  </p>
  <menuOverlay v-if="!isMobile" :length="length" :destination="destination" :hovered="hovered"></menuOverlay>

</nav>
</template>

<script>
import menuOverlay from '@/components/menuOverlay.vue';
export default {
  data() {
    return {
      hovered: false,
      destination: '',
      length: 0
    }
  },
  components: {
    menuOverlay
  },
  computed: {
    isMobile() {
      return this.$root.isMobile
    }
  },
  methods: {
    handleHoverLeave() {
      this.hovered = false;
    },
    handleHoverEnter(e) {
      if (!Number(e.target.dataset.length)) {
        return
      }
      this.destination = e.target.innerText.toLowerCase();
      this.hovered = true;
      this.length = Number(e.target.dataset.length)
    },
    handleMobile() {
      if (!this.isMobile) {
        this.hovered = false;
        return
      }
      this.$root.$emit('mobileMenuOpen', false)
    }
  }

}
</script>

<style lang="scss">
nav {
    a {
        transition: color 0.3s ease;
    }
    a,
    a:active,
    a:visited {
        color: $red;
        text-decoration: none;
    }
    a:hover {
        color: white !important;
        border: 2px white solid !important;

    }
}
</style>
